// b05 Marry-me-one-question — paper-invitation preview. Outer warm-paper
// foil, inner card uses template's bg/ink/accent. Eyebrow "TAKLIFNOMA" →
// heart-locket medallion (or photo) → recipient name → date and venue
// caption.

import { Photo, type LayoutCtx } from "./_shared";

const PAPER_GRADIENT =
  "linear-gradient(135deg, #B23A2F 0%, #D8806E 22%, #F2C9B7 45%, #D8806E 65%, #8C2218 100%)";

export function MarryMeOneQuestionPreviewLayout({
  names, date, venue, accent, ink, bg, font, photo,
}: LayoutCtx) {
  const captionDate = formatDate(date);
  const [a, b] = names.split(/\s*&\s*/);
  const display = b ? names : (a ?? names);
  return (
    <div style={{ position: "absolute", inset: 0, background: PAPER_GRADIENT, padding: "5%", display: "flex" }}>
      <div
        style={{
          flex: 1,
          background: bg,
          color: ink,
          position: "relative",
          padding: "8%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          boxShadow: `inset 0 0 0 1px ${accent}55`,
        }}
      >
        <div style={{ fontFamily: "var(--font-ui)", fontSize: 7, fontWeight: 700, letterSpacing: "0.4em", color: accent, marginBottom: "5%" }}>
          TAKLIFNOMA
        </div>

        {/* Heart-locket medallion */}
        <div style={{ width: "60%", aspectRatio: "1/1", position: "relative", marginBottom: "5%" }}>
          <div style={{ position: "absolute", inset: 0, borderRadius: "50%", background: PAPER_GRADIENT, padding: "5%" }}>
            <div style={{ width: "100%", height: "100%", borderRadius: "50%", background: bg, padding: "4%", boxSizing: "border-box" }}>
              <div style={{ width: "100%", height: "100%", borderRadius: "50%", overflow: "hidden", position: "relative" }}>
                <Photo
                  src={photo}
                  style={{ position: "absolute", inset: 0, width: "100%", height: "100%" }}
                  fallback={
                    <svg viewBox="0 0 100 100" style={{ position: "absolute", inset: 0, width: "100%", height: "100%" }}>
                      <defs>
                        <radialGradient id="b05-bg" cx="50%" cy="50%" r="55%">
                          <stop offset="0%" stopColor={accent} stopOpacity="0.32" />
                          <stop offset="100%" stopColor={bg} stopOpacity="0" />
                        </radialGradient>
                      </defs>
                      <rect width="100" height="100" fill="url(#b05-bg)" />
                      <path
                        d="M50 76 C 30 60 18 48 18 36 C 18 26 26 20 34 20 C 42 20 48 25 50 32 C 52 25 58 20 66 20 C 74 20 82 26 82 36 C 82 48 70 60 50 76 Z"
                        fill="none" stroke={accent} strokeWidth="1.2"
                      />
                      <path
                        d="M50 70 C 34 56 24 46 24 38 C 24 30 30 26 36 26 C 42 26 47 30 50 36 C 53 30 58 26 64 26 C 70 26 76 30 76 38 C 76 46 66 56 50 70 Z"
                        fill={accent} opacity="0.18"
                      />
                      <circle cx="50" cy="32" r="1.4" fill={accent} />
                    </svg>
                  }
                />
                <div style={{ position: "absolute", inset: 0, background: `linear-gradient(180deg, transparent 55%, ${accent}22 100%)` }} />
              </div>
            </div>
          </div>
        </div>

        <div style={{ fontFamily: font, fontSize: 28, lineHeight: 1.05, color: ink }}>
          {display}
        </div>

        <div style={{ flex: 1 }} />

        <div style={{ fontFamily: "var(--font-ui)", fontSize: 6.5, fontWeight: 700, letterSpacing: "0.32em", color: accent, marginTop: "4%" }}>
          ONE QUESTION · {captionDate}
        </div>
        <div style={{ fontFamily: "var(--font-ui)", fontSize: 6, fontWeight: 600, letterSpacing: "0.28em", color: `${ink}99`, marginTop: 6 }}>
          {venue.toUpperCase()}
        </div>
      </div>
    </div>
  );
}

function formatDate(d: string): string {
  const m = d.match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})$/);
  if (!m) return d.toUpperCase();
  const months = [
    "YANVAR", "FEVRAL", "MART", "APREL", "MAY", "IYUN",
    "IYUL", "AVGUST", "SENTABR", "OKTABR", "NOYABR", "DEKABR",
  ];
  return `${parseInt(m[1], 10)} ${months[parseInt(m[2], 10) - 1] ?? ""} ${m[3]}`;
}
